import React, { Component } from 'react'
import './DropdownMenu.css'
import PropTypes from 'prop-types'

class DropdownMenu extends Component {

    onSearchTermChange = event => {
        this.props.onSearchTermChange(event.target.value)
    }

    onClick = () => {
        this.props.onSearchBoxClick()
    }

    render() {
        return (
            <div className="z-dropdown" data-testid="dropdownMenu_divId_test">
                <div id="myDropdown" className="dropdownBorder">
                    <input data-testid="dropdownMenu_inputId_test" onClick={this.onClick} onKeyUp={this.onSearchTermChange} type="text" placeholder={this.props.placeholder} id="myInput" style={{ 'width': '100%' }} className="form-control text-black" />
                    {this.props.children}
                </div>
            </div>
        )
    }
}

DropdownMenu.propTypes = {
    children: PropTypes.any,
    onSearchTermChange: PropTypes.any,
    onSearchBoxClick: PropTypes.any,
    placeholder: PropTypes.any
}

export default DropdownMenu
